import React, { useState } from "react";

import classnames from "classnames";
import { Link } from "react-router-dom";
import {
  Col,
  Container,
  Nav,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";

//About Images
import testImg01 from "../../../assets/images/about/img-02.jpg";
import testImg02 from "../../../assets/images/about/img-03.jpg";
import testImg03 from "../../../assets/images/about/img-04.jpg";
import testImg04 from "../../../assets/images/about/img-05.jpg";

import { useLanguage } from "../../../context/LanguageContext";

const AboutCompany = () => {
  const { language } = useLanguage();
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  return (
    <React.Fragment>
      <section className="section">
        <Container>
          <Row className="align-items-center">
            <Col lg={5}>
              <div className="section-title mb-5 mb-lg-0">
                <h4 className="title mb-4">
                  {language === "pt" ? "Sobre a Empresa" : "About Company"}
                </h4>
                <p className="text-muted">
                  {language === "pt"
                    ? "Na EP Management & Consultancy Services, somos especializados em simplificar as complexidades do recrutamento, imigração, outsourcing e folha de pagamento em Moçambique. As nossas soluções abrangentes são concebidas para ajudar as empresas a superar desafios operacionais, impulsionar a eficiência e alcançar um crescimento sustentável."
                    : "At EP Management & Consultancy Services, we specialize in simplifying the complexities of recruitment, immigration, outsourcing, and payroll in Mozambique. Our comprehensive solutions are designed to help businesses overcome operational challenges, drive efficiency, and achieve sustainable growth."}
                </p>
                <ul className="list-unstyled about-list text-muted mt-4">
                  <li>
                    {language === "pt"
                      ? "Serviços de Recrutamento adaptados às necessidades do seu negócio."
                      : "Recruitment services tailored to your business needs."}
                  </li>
                  <li>
                    {language === "pt"
                      ? "Apoio em processos de Imigração para facilitar a mobilidade de talentos."
                      : "Immigration support to facilitate talent mobility."}
                  </li>
                  <li>
                    {language === "pt"
                      ? "Soluções de Outsourcing para otimizar operações e reduzir custos."
                      : "Outsourcing solutions to optimize operations and reduce costs."}
                  </li>
                  <li>
                    {language === "pt"
                      ? "Gestão de Folha de Pagamento eficiente e em conformidade legal."
                      : "Efficient and compliant Payroll management."}
                  </li>
                </ul>
                <div className="d-flex align-items-center justify-content-between mt-4">
                  <div>
                    <Link to="/contact" className="btn btn-outline-primary">
                      {language === "pt" ? "Saiba Mais" : "Know More"}{" "}
                      <i className="uil uil-angle-right-b ms-1"></i>
                    </Link>
                  </div>
                  <ul className="list-inline about-social-menu mb-0">
                    <li className="list-inline-item">
                      <Link
                        to="https://www.facebook.com/epmanagementconsult?mibextid=wwXIfr"
                        target="_blank"
                        className=""
                      >
                        <i className="uil uil-facebook-f"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link
                        to="https://www.linkedin.com/company/ep-management-consultancy-services/posts/?feedView=all"
                        target="_blank"
                        className=""
                      >
                        <i className="uil uil-linkedin-alt"></i>
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link
                        to="https://www.instagram.com/ep_management_cs"
                        target="_blank"
                        className=""
                      >
                        <i className="uil uil-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg={7}>
              <Row>
                <Col md={3}>
                  <Nav
                    tabs
                    className="about-testimonial-menu nav flex-sm-column flex-row nav-pills me-3"
                  >
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => {
                        toggle("1");
                      }}
                    >
                      <div className="position-relative">
                        <img src={testImg01} alt="" className="rounded" />
                        <div className="about-testi-bg-overlay">
                          <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                        </div>
                      </div>
                    </NavLink>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        toggle("2");
                      }}
                    >
                      <div className="position-relative">
                        <img src={testImg02} alt="" className="rounded" />
                        <div className="about-testi-bg-overlay">
                          <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                        </div>
                      </div>
                    </NavLink>
                    <NavLink
                      className={classnames({ active: activeTab === "3" })}
                      onClick={() => {
                        toggle("3");
                      }}
                    >
                      <div className="position-relative">
                        <img src={testImg03} alt="" className="rounded" />
                        <div className="about-testi-bg-overlay">
                          <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                        </div>
                      </div>
                    </NavLink>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        toggle("4");
                      }}
                    >
                      <div className="position-relative">
                        <img src={testImg04} alt="" className="rounded" />
                        <div className="about-testi-bg-overlay">
                          <i className="mdi mdi-plus-circle-outline text-white fs-3"></i>
                        </div>
                      </div>
                    </NavLink>
                  </Nav>
                </Col>

                <Col md={9}>
                  <TabContent
                    className="about-tab-content h-100"
                    activeTab={activeTab}
                  >
                    <TabPane
                      tabId="1"
                      className="fade rounded-3 show"
                      style={{ backgroundImage: `url(${testImg01})` }}
                    ></TabPane>
                    <TabPane
                      tabId="2"
                      className="fade rounded-3 show"
                      style={{ backgroundImage: `url(${testImg02})` }}
                    ></TabPane>
                    <TabPane
                      tabId="3"
                      className="fade rounded-3 show"
                      style={{ backgroundImage: `url(${testImg03})` }}
                    ></TabPane>
                    <TabPane
                      tabId="4"
                      className="fade rounded-3 show"
                      style={{ backgroundImage: `url(${testImg04})` }}
                    ></TabPane>
                  </TabContent>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default AboutCompany;
